export class UniqueEmailValidationRequest {
    email: string;
    userID: number;
}